import './footer.css'
import React from 'react'

function Footer() {
    const year = new Date().getFullYear(); // يحصل على السنة الحالية

  return (
    <div className='footer'>
        <div className="container text-center">
            <div className="row">
                <div className="col-12">
                    <p>جميع الحقوق محفوظة لمركز دكتور كار لصيانة السيارات {year}</p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Footer